import * as stylex from "@stylexjs/stylex";
import { AsyncRegion, Heading, SkeletonText } from "@softmax/design-system";
import { communityPageStyles as styles } from "./community-page.stylex";

export function CommunityPageLoading({ title }: { title: string }) {
  return (
    <main id="main" tabIndex={-1} {...stylex.props(styles.page)}>
      <AsyncRegion
        page
        pending
        label={`Loading ${title}`}
        placeholder={
          <div {...stylex.props(styles.placeholder)}>
            <Heading level={1} variant="title">
              {title}
            </Heading>
            <SkeletonText lines={5} />
          </div>
        }
      />
    </main>
  );
}
